import script from "./tabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./tabs.vue?vue&type=script&lang=ts&setup=true"

import "./tabs.vue?vue&type=style&index=0&id=175e224a&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-175e224a"]])

export default __exports__